import { AfterViewInit, Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import {
  BalanceQuery,
  Barcode,
  config,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  ProductCodeQuery,
  ScreenType,
  SeatingDetail,
} from '@fgb/core';
import { map, Observable } from 'rxjs';
import { ProductCode, ShouldSeePartners } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit, AfterViewInit {
  @ViewChild('nav', { static: false }) navRef!: ElementRef<HTMLDivElement>;
  atRightEnd = false;
  displayPartner: boolean = false;

  @Input() isHomePage = false;

  screenType = ScreenType;
  isTrialMember: boolean;
  barcode$: Observable<Barcode>;
  card$: Observable<MemberCard | undefined>;
  member$: Observable<MemberDetails | undefined>;
  seatingDetail$: Observable<SeatingDetail | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  ecash$: Observable<number | undefined>;
  pointsBalance$: Observable<number | undefined>;
  productCode = ProductCode;

  constructor(
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private productCodeQuery: ProductCodeQuery,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();

    this.pointsBalance$ = this.balanceQuery
      .selectPurse(config.purseConfig.virtualLoyalty)
      .pipe(map((bal) => Math.ceil(bal ?? 0)));

    this.displayPartner = this.productCodeQuery.currentUserIsProductCode(ShouldSeePartners);
  }

  //hide after for mobile nav
  ngAfterViewInit() {
    this.updateRightEnd();

    this.ngZone.runOutsideAngular(() => {
      const handler = () => this.ngZone.run(() => this.updateRightEnd());
      window.addEventListener('resize', handler);
    });
  }

  onNavScroll() {
    this.updateRightEnd();
  }

  private updateRightEnd() {
    const el = this.navRef?.nativeElement;
    if (!el) return;

    const { scrollLeft, clientWidth, scrollWidth, dir } = el;

    const isRtl = (dir || getComputedStyle(el).direction) === 'rtl';
    const current = isRtl ? Math.abs(scrollLeft) : scrollLeft;

    const epsilon = 1;
    this.atRightEnd = current + clientWidth >= scrollWidth - epsilon;
  }
}
